<template>
    <div class="folder-list-container">
        <div class="folder-list-title">文件夹列表</div>
        <div class="folder-list-operation">
            <div class="folder-list-add" @click="addFolder">
                <i class="el-icon-folder-add"></i>新增
            </div>
            <div class="folder-list-modify" @click="modifyFolder">
                <i class="el-icon-document"></i>修改
            </div>
            <div class="folder-list-delete" @click="deleteFolder">
                <i class="el-icon-delete"></i>删除
            </div>
        </div>
        <ul class="folder-list">
            <li v-for="(item, index) in folder" :key="index" :class="{active: activeIndex === index}"
                @click="clickHandle(index, item)">
                <i class="el-icon-folder-opened" style="margin-right: 10rem"></i>{{item}}
            </li>
        </ul>
    </div>
</template>

<script>
    import {
        AddFolder,
        ModifyFolder,
        DeleteF,
    } from '@/api/equipment';
    export default {
        props: {
            folder: Array,
        },
        data() {
            return {
                activeIndex: 0,
                activeName: this.folder[0],
            }
        },
        mounted() {
            // console.log(this.activeName);
            // console.log(this.activeIndex);
        },
        computed: {
            projectId: function () {
                return this.$store.getters.projectId;
            }
        },
        watch: {
            folder(n, o) {
                if (this.activeName) {
                    this.activeIndex = n.findIndex(item => item == this.activeName)
                } else {
                    this.activeIndex = 0
                    this.activeName = this.folder[0]
                }
            }
        },
        methods: {
            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error('response error: code is not 200 or status is not true');
                    return null;
                }
                return data;
            },
            clickHandle: function (index, item) {
                if (this.activeIndex === index)
                    return;
                this.activeIndex = index;
                this.activeName = item
                this.$emit('openFolder', item);
            },
            addFolder() {
                this.$prompt('文件夹名字: ', '新建文件夹', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({
                    value
                }) => {
                    AddFolder(this.projectId, value).then(res => {
                        if (res.data.code == 200) {
                            this.$parent.getAll(this.activeName).then(() => {
                                this.activeIndex = this.folder.findIndex(item => item == this
                                    .activeName)
                                this.$message({
                                    type: 'success',
                                    message: '新建文件夹: ' + value
                                });
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.errMsg
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            modifyFolder() {
                this.$prompt('文件夹名字: ', '重命名文件夹', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue: this.activeName,
                }).then(({
                    value
                }) => {
                    ModifyFolder(this.projectId, this.activeName, value).then(res => {
                        if (res.data.code == 200) {
                            this.$parent.getAll(value).then(() => {
                                this.activeIndex = this.folder.findIndex(item => item == value)
                                this.activeName = value
                                this.$message({
                                    type: 'success',
                                    message: '重命名文件夹: ' + value
                                });
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.errMsg
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            deleteFolder() {
                this.$confirm(`从列表中删除“${this.activeName}”。`, '确认删除文件夹吗?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let path = '/' + this.activeName
                    DeleteF(this.projectId, path).then(res => {
                        if (res.data.code == 200) {
                            this.$parent.getAll().then(() => {
                                this.activeIndex = 0
                                this.activeName = this.folder[0]
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.errMsg
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消删除'
                    });
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .folder-list-container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;

        .folder-list-title {
            padding-left: 25rem;
            .h(97);
            display: flex;
            align-items: center;
            border-bottom: 1px solid #E5E5E5;

            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }

        .folder-list-operation {
            display: flex;
            .h(64);
            justify-content: space-around;
            align-items: center;

            font-size: 18rem;
            font-weight: 400;
            color: #333333;

            .folder-list-add {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                width: 33.3%;
                height: 100%;
            }

            .folder-list-modify {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                width: 33.3%;
                height: 100%;
            }

            .folder-list-delete {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                width: 33.3%;
                height: 100%;
            }

            i:after {
                content: '';
                margin-right: 7rem;
            }
        }

        .folder-list {
            flex: 1;

            li {
                width: 100%;
                .h(53);
                display: flex;
                align-items: center;
                padding-left: 24rem;
                cursor: pointer;

                font-size: 18rem;
                font-weight: 400;
                color: #666666;
            }

            .active {
                font-weight: bold;
                color: #0D94FF;
            }
        }
    }
</style>